<template>

<!--  <ref_img/>-->
  <main_page/>


</template>

<script>
import main_page from './components/main_page';
// import ref_img from './components/ref_img';

export default {
  name: 'App',
  components: {
    // ref_img,
    main_page,
  }
}
</script>

<style lang="stylus">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;


}

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-weight: inherit;
  font-style: inherit;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline
}
  html
    font-size 1px


body {
  line-height: 1;
  color: #222;

  overflow-x hidden
}

ol, ul {
  list-style: none
}

table {
  border-collapse: separate;
  border-spacing: 0;
  vertical-align: middle
}

caption, th, td {
  text-align: left;
  font-weight: normal;
  vertical-align: middle
}

a img {
  border: none
}

body {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.v-lazy-image
  opacity 0
  transition: all 0.3s linear;


.v-lazy-image-loaded
  opacity 1



</style>
